import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-avg-element',
  templateUrl: './delete-avg-element.component.html',
  styleUrls: ['./delete-avg-element.component.scss']
})
export class DeleteAvgElementComponent implements OnInit {

  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
